<span *transloco="let t">
  @if (strategy(); as strategy) {
    <div class="mb-4">
      <app-low-inventory-warning
        [accountId]="strategy.accountId"
        [marketplace]="strategy.marketplace"
        [asins]="strategy.asins | map: getAsins"
      ></app-low-inventory-warning>
    </div>

    <div>
      <div class="flex items-center justify-between">
        <div class="flex flex-1 items-center justify-end gap-2">
          @if (creativeLimitSoonReached()) {
            <div class="alert alert-warning mb-0">
              {{
                t("sb-page.maximum_almost_reached", {
                  count: creatives()?.length ?? 0,
                  limit: maxCreativesPerStrategy,
                })
              }}
            </div>
          } @else if (!canCreateNewCreative()) {
            <div class="alert alert-warning mb-0">
              {{ t("sb-page.max_reached", { limit: maxCreativesPerStrategy }) }}
            </div>
          }

          @if (!isReadOnly()) {
            <button
              iButton
              variant="secondary"
              [iTooltip]="
                !canCreateNewCreative() ? t('sb-page.no_more_than_X_creatives', { limit: maxCreativesPerStrategy }) : ''
              "
              [disabled]="!canCreateNewCreative()"
              (click)="newCreative()"
            >
              <IIcon name="plus" />
              {{ t("sb-page.new_ad_line") }}
            </button>
          }
        </div>
      </div>
      <div class="pt-2">
        <div class="flex">
          <IMultiSelectMenu [(value)]="selectedCreativeTypes">
            <ISelectTrigger size="sm">
              <ISelectValue [placeholder]="t('sb-page.creative_type')">
                <div *iSelectValue="let value" class="flex items-center gap-1">
                  <IIcon name="filter" class="text-muted-foreground size-5 shrink-0" />
                  @for (selected of value; track selected) {
                    <span>
                      {{ selected.label + ($last ? "" : ", ") }}
                    </span>
                  }
                </div>
              </ISelectValue>
            </ISelectTrigger>
            <ISelectContent>
              @for (option of creativeTypesOptions; track option) {
                <ISelectOption [value]="option">
                  {{ option.label }}
                </ISelectOption>
              }
            </ISelectContent>
          </IMultiSelectMenu>
        </div>
        <div class="mt-4 flex max-w-3xl flex-col gap-4">
          @for (creative of filteredCreatives(); track creative.creativeId) {
            <app-sb-creative-card
              [creative]="creative"
              [strategyId]="strategy.strategyId"
              [creatives]="creatives() ?? []"
              [readOnly]="!!isReadOnly()"
            />
          } @empty {
            <p>{{ t("sb-page.no_creative_for_the_selected_filter") }}</p>
          }
        </div>
      </div>
    </div>
  }
</span>
